import { useState, useRef } from 'react';
import axios from '../api'; // or wherever your axios instance is
import { Message } from '../utils/types';



type Props = {
  selectedConversationId: number | '';
  senderId: number;
  setMessages: React.Dispatch<React.SetStateAction<any[]>>;

  replyTo: Message | null;
  setReplyTo: React.Dispatch<React.SetStateAction<Message | null>>;
};
export default function ChatInput({ selectedConversationId, senderId, setMessages, replyTo, setReplyTo  }: Props) {
  
  
  const [files, setFiles] = useState<File[]>([]);
  const [message, setMessage] = useState('');
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);

  const handleFilesSelect = (files: FileList) => {
    const newFiles = Array.from(files);
    setSelectedFiles((prev) => [...prev, ...newFiles]);
    const newPreviews = newFiles.map(file => URL.createObjectURL(file));
    setPreviewUrls((prev) => [...prev, ...newPreviews]);
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) handleFilesSelect(e.target.files);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files) handleFilesSelect(e.dataTransfer.files);
  };

  const handleSend = async () => {
    if(message.trim()!=='' || selectedFiles.length>0){
      const formData = new FormData();
      formData.append('content', message);
      formData.append('conversationId', selectedConversationId.toString());
      selectedFiles.forEach((file) => {
        formData.append('files', file);
      });
      if (replyTo) {
        formData.append('replyToId', replyTo.id.toString());
      }
      console.log('formData',formData);
      
      try {
        await axios.post('http://localhost:3000/messages/send', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        // ✅ Clear input & previews after successful send
        setMessage('');
        setSelectedFiles([]);
        setPreviewUrls([]);
      } catch (err) {
        console.error('Upload failed:', err);
      }
    }
  };

 

  return (
    
    <div
      className="p-2 border-t"
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      {replyTo && (
        <div className="bg-gray-100 p-2 rounded mb-2 relative">
          <div className="text-sm text-gray-700">
            Replying to <strong>{replyTo.sender.name}</strong>: {replyTo.content}
          </div>
          <button
            onClick={() => setReplyTo(null)}
            className="absolute top-1 right-2 text-gray-500 hover:text-black text-sm"
          >
            ✕
          </button>
        </div>
      )}
      <div className="flex items-center gap-2">
        <input
          type="file"
          multiple
          hidden
          id="fileInput"
          onChange={handleFileInputChange}
        />
        <label htmlFor="fileInput" className="cursor-pointer px-3 py-1 bg-gray-100 rounded">
          📎
        </label>

        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type a message"
          className="flex-1 border px-3 py-2 rounded"
        />

        <button
          onClick={handleSend}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Send
        </button>
        
      </div>


      
      {previewUrls.length > 0 && (
        <div className="flex gap-2 mt-2 flex-wrap">
          {previewUrls.map((url, i) => {
            const ext = selectedFiles[i]?.name.split('.').pop()?.toLowerCase();
            const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(ext || '');

            let icon = '📄'; // Default file icon
            if (ext === 'pdf') icon = '📕';
            else if (ext === 'doc' || ext === 'docx') icon = '📘';
            else if (ext === 'xls' || ext === 'xlsx') icon = '📗';
            else if (ext === 'zip' || ext === 'rar') icon = '🗜️';

            return (
              <div key={i} className="relative">
                {isImage ? (
                  <img
                    src={url}
                    alt="preview"
                    className="w-20 h-20 object-cover rounded"
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                ) : (
                  <div className="w-40 p-2 bg-gray-100 rounded flex flex-col items-center text-sm">
                    <div className="text-3xl">{icon}</div>
                    <div className="mt-1 text-center truncate w-full">{selectedFiles[i]?.name}</div>
                    <div className="text-xs text-gray-500">
                      {(selectedFiles[i]?.size / 1024).toFixed(1)} KB
                    </div>
                  </div>
                )}

                <button
                  className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded"
                  onClick={() => {
                    const newFiles = [...selectedFiles];
                    const newUrls = [...previewUrls];
                    newFiles.splice(i, 1);
                    newUrls.splice(i, 1);
                    setSelectedFiles(newFiles);
                    setPreviewUrls(newUrls);
                  }}
                >
                  ✕
                </button>
              </div>
            );
          })}

        </div>
      )}
    </div>

  );
}